import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAccountChildLeads as GetAccountChildLeadsQuery,
    PeepRelatedLeadFragment as Lead,
    GetAccountChildLeads_account as Account,
    GetAccountChildLeadsVariables as GetAccountChildLeadsQueryVariables,
    PeepRelatedLeadStatsFragment,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_CHILD_LEADS from '../../graphql/queries/get-account-child-leads.graphql';

export const useGetAccountChildLeads = (
    accountId: string,
    skip: boolean = false
): {
    account: Account | undefined;
    leads: Lead[] | undefined;
    stats: PeepRelatedLeadStatsFragment | null | undefined;
    childAccountIds: string[] | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
    } = useQuery<GetAccountChildLeadsQuery, GetAccountChildLeadsQueryVariables>(
        GET_ACCOUNT_CHILD_LEADS,
        {
            variables: {accountId: accountId},
            fetchPolicy: 'cache-and-network',
            skip,
        }
    );

    return {
        account: data?.account ?? undefined,
        leads: data?.account?.childLeads?.edges?.map((edge) => edge.node),
        stats: data?.account?.childLeads?.subsidiaryStats,
        childAccountIds: data?.account?.childAccounts?.edges?.map((edge) => edge.node.id),
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
